if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]")
          ? (this.form.querySelector("[name=id]").disabled = false)
          : null;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitBis = this.querySelector(".bis_container button");
        this.submitBis?.addEventListener("click", this.bisHandler.bind(this));
        if (document.querySelector("cart-drawer") && this.submitButton)
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        if (this.submitButton.getAttribute("bis") === "true") {
          this.classList.add("bis_is-active");
          this.bisHandler();
          return;
        }

        if (this.submitButton.getAttribute("bis") === "true") {
          this.submitButton.addEventListener(
            "click",
            this.bisHandler.bind(this)
          );
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        // The mobile sticky CTA forwards its taps to this inline button but lives
        // outside the form, so it never gets visual feedback on its own. Mirror the
        // loading state onto it while the add request is in flight.
        this.stickyAtcButton = this.submitButton.classList.contains("bouton-atc")
          ? document.querySelector("#atc-btn-mobile")
          : null;
        this.stickyAtcButton?.classList.add("loading");
        this.querySelector(".loading-overlay__spinner")?.classList.remove(
          "hidden"
        );
        if (document.querySelector("floating-form")) {
          document
            .querySelector('floating-form [type="submit"]')
            .classList.add("loading");
          document
            .querySelector('floating-form [type="submit"]')
            .setAttribute("aria-disabled", true);
          document
            .querySelector("floating-form .loading-overlay__spinner")
            .classList.remove("hidden");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              if (window.routes.path.includes("/checkouts/")) {
                location.reload();
              } else {
                window.location = window.routes.cart_url;
                return;
              }
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;

            // Reset the forced size selection so the next add requires a fresh pick
            const variantSelects = document.getElementById(
              `variant-selects-${this.dataset.sectionId}`
            );
            if (
              variantSelects &&
              typeof variantSelects.resetSizeSelection === "function"
            ) {
              variantSelects.resetSizeSelection();
            }

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            this.stickyAtcButton?.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner")?.classList.add(
              "hidden"
            );
            if (document.querySelector("floating-form")) {
              document
                .querySelector('floating-form [type="submit"]')
                .classList.remove("loading");
              document
                .querySelector('floating-form [type="submit"]')
                .removeAttribute("aria-disabled");
              document
                .querySelector("floating-form .loading-overlay__spinner")
                .classList.add("hidden");
            }
          });
      }

      bisHandler() {
        const variantId = this.querySelector("[name='id']").value;
        const emailField = this.querySelector("[name='email']");
        const email = emailField.value;

        if (email.length > 0) {
          const options = {
            email,
            variant: variantId,
          };
          const klaviyo = new Klaviyo()
            .backInStockSubscribe(options)
            .then((response) => {
              if (response.status == 202) {
                this.querySelector(".bis_container").classList.add(
                  "is_success"
                );
              } else {
                this.querySelector(".bis_container").classList.add("has_error");
                emailField.focus();
              }
            })
            .catch((e) => {
              console.error(e);
            });
        } else {
          emailField.focus();
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
